module.exports = __webpack_public_path__ + "static/media/24.2db23295.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/24.mp3
// module id = 500
// module chunks = 0